import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";

import HelloSuperStarLogo from "../../Assets/Images/HelloSuperStarLogo.png";
import Retrieve from "../../Assets/Icon/icon/retrieve.png";
import DropDownLanguage from "./DropDownLanguage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { PlayArrow } from "@material-ui/icons";

const NewPassword = () => {
  const location = useLocation();
  const { state } = location;

  let history = useHistory();

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [conPassword, setConPassword] = useState("");
  const [buffer, setBuffer] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handelPasswordChange = () => {
    let data = {
      email: state.email,
      code,
      password,
    };

    if (code != "") {
      if (password == conPassword) {
        if(password.length>4 ){
          setBuffer(true);
          axios
              .post("/api/user_forget_password_store", data)
              .then((res) => {
                setBuffer(false);

                if (res.data.status == 200) {
                  setErrorMessage("");
                  history.push({
                    pathname: "/login",
                  });
                } else {
                  setErrorMessage("OPT do not match");
                }
              })
              .catch((err) => {
                setBuffer(false);
              });
        }else {
          setErrorMessage("Password must be at least 5 characters long");
        }
      } else {
        setErrorMessage("Passwords do not match");
      }
    } else {
      setErrorMessage("Code is empty");
    }
  };

  const [changeIcon, setChange] = useState(false);
  function handleChangeIcon() {
    setChange(!changeIcon);
  }

  const [changeIcon2, setChange2] = useState(false);
  function handleChangeIcon2() {
    setChange2(!changeIcon2);
  }
  return (
    <>
      <div className="bg-img mobileLog">
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div
              className="col-md-12  mx-auto row d-flex justify-content-between align-items-center"
              style={{ minHeight: "100vh" }}
            >
              <div className="col-md-6 align-items-center ">
                <center>
                  {" "}
                  <div>
                    <img
                      src={HelloSuperStarLogo}
                      alt="Hello Super Star Logo "
                      className="MobileLogoLog"
                    />
                  </div>
                  <div>
                    <Link to="/tutorial">
                      <button className="btn mt-3 TabBtnLog px-4 Virtual">
                        <PlayArrow />
                        <span className="mx-2 ">Virtual Tour</span>
                      </button>
                    </Link>
                  </div>
                </center>
              </div>

              <div className="col-md-6 align-items-center mobile-sign-view">
                <center className="col-sm-12 col-md-12 col-lg-10 custom-si-desk">
                  <div className="d-flex align-items-center justify-content-center ">
                    <div className="wrapperLog LogBgColor">
                      <center className="mt-3">
                        <img
                          src={Retrieve}
                          alt=""
                          className="img-fluid LogoImg"
                        />
                      </center>
                      <form>
                        <center>
                          {" "}
                          <h4 className=" card-text lead fw-bold text-warning">
                            Create a new password!
                          </h4>
                          <small className="text-muted">
                            <p className="m-0 p-0">
                              Please Enter the 6 digits otp send to
                            </p>
                          </small>
                          <small className="retrieve-text">
                            <b>{state?.email}</b>
                          </small>
                          <br />
                          <small className="text-danger">
                            <b>{errorMessage}</b>
                          </small>
                        </center>

                        <div className="field">
                          <input
                            type="text"
                            required
                            className="inp-padding"
                            placeholder="Enter your otp "
                            onChange={(e) => setCode(e.target.value)}
                            value={code}
                          />

                          <span className="code_ic">
                            <small className="otp-te">OTP</small>
                          </span>
                        </div>
                        <div className="field">
                          <input
                            type={changeIcon ? `text` : `password`}
                            name="password"
                            className="inp-padding"
                            placeholder="Enter your new password "
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                          />
                          <span className="code_ic">
                            <small className="otp-te">🌕</small>
                          </span>

                          <span
                            onClick={handleChangeIcon}
                            className="eye-icons"
                          >
                            <FontAwesomeIcon
                              icon={changeIcon ? faEye : faEyeSlash}
                            />
                          </span>
                        </div>
                        <div className="field">
                          <input
                            type={changeIcon2 ? `text` : `password`}
                            name="password"
                            className="inp-padding"
                            required
                            placeholder="Enter your confirm password "
                            onChange={(e) => setConPassword(e.target.value)}
                            value={conPassword}
                          />
                          <span className="code_ic">
                            <small className="otp-te">🌕</small>
                          </span>

                          <span
                            onClick={handleChangeIcon2}
                            className="eye-icons"
                          >
                            <FontAwesomeIcon
                              icon={changeIcon2 ? faEye : faEyeSlash}
                            />
                          </span>
                        </div>
                        <Button
                          className="btn BtnLogin my-4 w-100"
                          onClick={handelPasswordChange}
                        >
                          {buffer ? (
                            <>
                              <i className="fas fa-spinner fa-pulse"></i> &nbsp;
                              Submit
                            </>
                          ) : null}
                          Send
                        </Button>
                      </form>
                    </div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>

        <div className="topright text-light">
          <DropDownLanguage />
        </div>
      </div>
    </>
  );
};

export default NewPassword;
